// File: frontend/src/components/dfs/scoreTypeIcons.tsx
//
// Score-type glyphs and the +/- color rule shared by the per-player
// ScoreBreakdownModal (extracted so other surfaces can reuse them).

import { ReactNode } from 'react';
import { Target, Zap, KeyRound, Handshake, MoveRight, Footprints, XCircle, BarChart3, Icon } from 'lucide-react';
import { soccerBall } from '@lucide/lab';

const iconClass = 'text-accent-yellow';

export const SCORE_TYPE_ICONS: Record<string, ReactNode> = {
  'Goal': <Icon iconNode={soccerBall} size={14} className={iconClass} />,
  'ShotOnTarget': <Target size={14} className={iconClass} />,
  'Shot': <Zap size={14} className={iconClass} />,
  'ProgPass': <MoveRight size={14} className={iconClass} />,
  'ProgCarry': <Footprints size={14} className={iconClass} />,
  'SCA': <Handshake size={14} className={iconClass} />,
  'GCA': <KeyRound size={14} className={iconClass} />,
  'Dispossessed': <XCircle size={14} className={iconClass} />,
};

export const getScoreTypeIcon = (scoreType: string | null | undefined): ReactNode => {
  if (!scoreType) return <BarChart3 size={14} />;
  return SCORE_TYPE_ICONS[scoreType] || <span>•</span>;
};

export const getScoreTypeColorClass = (points: number): string => {
  if (points > 0) return 'text-green-400';
  if (points < 0) return 'text-red-400';
  return 'text-gray-400';
};
